<template>
	<el-aside width="240px" style="background: #287AFF;overflow: hidden;min-height: 100vh;">
		<div class="aside-title">
			<a href="https://www.id-photo-verify.com/edu/admin/#/"><img src="../assets/logo.png"></a>
		</div>
		<el-menu router background-color="#287AFF" active-text-color="#FFFFFF" text-color="#FFFFFF" style="width: 240px;">
			<el-menu-item index="/setBasicInfo" >
				<span slot="title">基础信息设置</span>
			</el-menu-item>
			<el-menu-item index="/setTopSpec" >
				<span slot="title">热门规格设置</span>
			</el-menu-item>
			<el-menu-item index="/setImages" >
				<span slot="title">图片设置</span>
			</el-menu-item>
			<el-menu-item index="/userInfo" >
				<span slot="title">用户信息表</span>
			</el-menu-item>
			<el-menu-item index="/orders" >
				<span slot="title">用户订单表</span>
			</el-menu-item>
		</el-menu>
	</el-aside>

</template>

<script>
	export default {
		data(){
			return{
				
			}
		},
		created() {
			
		}
	}
</script>

<style>
.el-menu-item.is-active{
	background: #1B6AE8 !important;
}

.el-menu-item, .el-submenu__title{
	height: 50px;
	line-height: 50px;
}
.aside-title{
	height: 70px;
	display: flex;
	align-items: center;
}
.aside-title img{
	height: 41px;
	margin-left: 15px;
}
</style>
